import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type NavItem = {
    id: string;
    label: string;
    icon: string;
    link?: string;
    action?: 'workspace';
    activePaths?: string[];
    badgeKey?: string;
    badgeTone?: string;
    roles?: string[];
};

type NavGroup = {
    label: string;
    items: NavItem[];
    roles?: string[];
};

const NAV_ITEMS: Record<string, NavItem> = {
    workspace: {
        id: 'workspace',
        label: '진료 보드',
        icon: 'fa-solid fa-notes-medical',
        action: 'workspace',
        activePaths: ['/dashboard', '/chart'],
        badgeKey: 'doctor_queue',
        badgeTone: 'emerald',
    },
    reception: {
        id: 'reception',
        link: '/reception',
        label: '접수 보드',
        icon: 'fa-solid fa-clipboard-list',
        activePaths: ['/reception'],
        badgeKey: 'ops_queue',
        badgeTone: 'amber'
    },
    prescriptions: {
        id: 'prescriptions',
        link: '/prescriptions',
        label: '처방 마무리',
        icon: 'fa-solid fa-prescription',
        activePaths: ['/prescriptions'],
        badgeKey: 'review_queue',
        badgeTone: 'violet'
    },
    patients: {
        id: 'patients',
        link: '/patients',
        label: '환자 목록',
        icon: 'fa-solid fa-users',
        activePaths: ['/patients']
    },
    intake: {
        id: 'intake',
        link: '/intake',
        label: '사전 예진',
        icon: 'fa-solid fa-file-medical',
        activePaths: ['/intake']
    },
    posts: {
        id: 'posts',
        link: '/posts',
        label: '공지 · 메모',
        icon: 'fa-solid fa-comments',
        activePaths: ['/posts']
    },
    members: {
        id: 'members',
        link: '/members',
        label: '조직 멤버',
        icon: 'fa-solid fa-user-group',
        activePaths: ['/members'],
        roles: ['admin', 'superadmin']
    },
    scenario: {
        id: 'scenario',
        link: '/scenario',
        label: '서비스 시나리오',
        icon: 'fa-solid fa-scroll',
        activePaths: ['/scenario'],
        roles: ['admin', 'superadmin']
    },
    prompt: {
        id: 'prompt',
        link: '/admin/prompt',
        label: 'AI 운영',
        icon: 'fa-solid fa-robot',
        activePaths: ['/admin/prompt'],
        roles: ['admin', 'superadmin']
    },
    diagnosis: {
        id: 'diagnosis',
        link: '/admin/diagnosis',
        label: '진단 기준',
        icon: 'fa-solid fa-tags',
        activePaths: ['/admin/diagnosis'],
        roles: ['admin', 'superadmin']
    },
    herbs: {
        id: 'herbs',
        link: '/admin/herbs',
        label: '본초 · 방제',
        icon: 'fa-solid fa-mortar-pestle',
        activePaths: ['/admin/herbs'],
        roles: ['admin', 'superadmin']
    },
    acupoints: {
        id: 'acupoints',
        link: '/admin/acupoints',
        label: '경혈 기준',
        icon: 'fa-solid fa-location-dot',
        activePaths: ['/admin/acupoints'],
        roles: ['admin', 'superadmin']
    },
    users: {
        id: 'users',
        link: '/admin/users',
        label: '사용자 · 권한',
        icon: 'fa-solid fa-user-shield',
        activePaths: ['/admin/users'],
        roles: ['admin', 'superadmin']
    },
    settings: {
        id: 'settings',
        link: '/admin/settings',
        label: '시스템 설정',
        icon: 'fa-solid fa-gear',
        activePaths: ['/admin/settings'],
        roles: ['admin', 'superadmin']
    },
};

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
}

.nav-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(180deg, #e7edf3 0%, #ecf1f6 100%);
  color: #0f172a;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #d4dde7;
  background: linear-gradient(180deg, #e3eaf1 0%, #e7edf3 100%);
  cursor: pointer;
}

.nav-brand-mark {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #94a3b8;
  background: #ffffff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #334155;
  flex-shrink: 0;
}

.nav-brand-title {
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  color: #0f172a;
}

.nav-brand-sub {
  margin-top: 3px;
  font-size: 10px;
  line-height: 1;
  color: #64748b;
}

.nav-station {
  padding: 10px 12px 12px;
  border-bottom: 1px solid #d4dde7;
  background: #eef3f7;
}

.nav-station-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.nav-focus {
  width: 100%;
  margin-top: 8px;
  padding: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #cfd8e3;
  background: #ffffff;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
  cursor: pointer;
}
.nav-focus:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.nav-focus-copy {
  min-width: 0;
  flex: 1;
}

.nav-focus-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.nav-focus-value {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
  color: #0f172a;
}

.nav-focus-sub {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.35;
  color: #64748b;
}

.nav-focus-cta {
  padding: 3px 6px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  color: #334155;
}

.nav-meter-grid {
  margin-top: 6px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px;
}

.nav-meter {
  padding: 7px 8px;
  border: 1px solid #d5dee8;
  background: rgba(255, 255, 255, 0.82);
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
  cursor: pointer;
}
.nav-meter:hover {
  background: #ffffff;
  border-color: #94a3b8;
}
.nav-meter strong {
  display: block;
  margin-top: 3px;
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.nav-meter-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.nav-sections {
  flex: 1;
  overflow: auto;
  padding: 10px 0 12px;
}

.nav-section + .nav-section {
  margin-top: 8px;
}

.nav-section-title {
  padding: 0 12px;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.nav-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px 8px 10px;
  border: 0;
  border-left: 3px solid transparent;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  background: transparent;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
  cursor: pointer;
}
.nav-row:hover {
  background: #f8fafc;
}

.nav-row--active {
  background: #ffffff;
  border-left-color: #2563eb;
  border-top-color: #dbe4ee;
  border-bottom-color: #dbe4ee;
}

.nav-row-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.nav-row-main i {
  width: 14px;
  font-size: 12px;
  color: #64748b;
  text-align: center;
  flex-shrink: 0;
}

.nav-row--active .nav-row-main i {
  color: #2563eb;
}

.nav-row-label {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-row-side {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.nav-row-arrow {
  font-size: 10px;
  color: #94a3b8;
}

.nav-item-badge {
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}

.nav-item-badge--amber {
  background: #fef3c7;
  color: #b45309;
}

.nav-item-badge--emerald {
  background: #d1fae5;
  color: #047857;
}

.nav-item-badge--violet {
  background: #ede9fe;
  color: #6d28d9;
}

.nav-item-badge--slate {
  background: #e2e8f0;
  color: #475569;
}

.nav-footer {
  border-top: 1px solid #d4dde7;
  padding: 10px 12px;
  background: #eef3f7;
}

.profile-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border: 1px solid transparent;
  transition: background-color 0.15s, border-color 0.15s;
}
.profile-card:hover {
  background: #ffffff;
  border-color: #dbe4ee;
}

.profile-card--active {
  background: #ffffff;
  border-color: #dbe4ee;
}

.nav-profile-avatar {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.nav-profile-name {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
}

.nav-profile-role {
  margin-top: 2px;
  font-size: 10px;
  line-height: 1.2;
  color: #64748b;
}

.nav-logout {
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  font-size: 10px;
  color: #64748b;
  transition: color 0.15s;
}
.nav-logout:hover {
  color: #b91c1c;
}`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    public queueCounts: any = {
        waiting: 0,
        intake: 0,
        ready: 0,
        ops_queue: 0,
        doctor_queue: 0,
        review_queue: 0,
        active_queue: 0,
        next_visit: null,
    };
    public navGroups: NavGroup[] = [];
    private refreshTimer: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.navGroups = this.buildNavGroups();
        await this.loadWaitingCount();
        this.refreshTimer = setInterval(() => this.loadWaitingCount(), 30000);
    }

    ngOnDestroy() {
        if (this.refreshTimer) clearInterval(this.refreshTimer);
    }

    public async loadWaitingCount() {
        try {
            const { code, data } = await wiz.call('waiting_count');
            if (code === 200) {
                this.queueCounts = data || this.queueCounts;
                await this.service.render();
            }
        } catch (e) { }
    }

    public visibleNavGroups() {
        return this.navGroups
            .filter((group) => this.canAccess(group.roles))
            .map((group) => ({
                ...group,
                items: group.items.filter((item) => this.canAccess(item.roles))
            }))
            .filter((group) => group.items.length > 0);
    }

    public itemClass(item: NavItem) {
        if (this.isItemActive(item)) {
            return 'nav-row nav-row--active';
        }
        return 'nav-row';
    }

    public isItemActive(item: NavItem) {
        const paths = item.activePaths || (item.link ? [item.link] : []);
        return paths.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`));
    }

    public openNav(item: NavItem) {
        if (item.action === 'workspace') {
            this.openWorkspace();
            return;
        }

        if (item.link) {
            this.service.href(item.link);
        }
    }

    public openWorkspace() {
        if (this.queueCounts?.next_visit?.id) {
            this.service.href(`/chart/${this.queueCounts.next_visit.id}`);
            return;
        }

        if (this.isOpsRole() || (this.queueCounts?.ops_queue || 0) > 0) {
            this.service.href('/reception');
            return;
        }

        this.service.href('/dashboard');
    }

    public openReviewQueue() {
        this.service.href('/prescriptions');
    }

    public hasBadge(item: NavItem) {
        if (!item.badgeKey) return false;
        return Number(this.queueCounts?.[item.badgeKey] || 0) > 0;
    }

    public badgeValue(item: NavItem) {
        if (!item.badgeKey) return '';
        const value = Number(this.queueCounts?.[item.badgeKey] || 0);
        if (value > 99) return '99+';
        return `${value}`;
    }

    public badgeClass(item: NavItem) {
        const tone = item.badgeTone || 'slate';
        const map: any = {
            amber: 'nav-item-badge nav-item-badge--amber',
            emerald: 'nav-item-badge nav-item-badge--emerald',
            violet: 'nav-item-badge nav-item-badge--violet',
            slate: 'nav-item-badge nav-item-badge--slate',
        };
        return map[tone] || map.slate;
    }

    public focusTitle() {
        if (this.queueCounts?.next_visit?.patient_name) {
            return '다음 환자';
        }

        if ((this.queueCounts.ops_queue || 0) > 0) {
            return '접수 대기';
        }

        if ((this.queueCounts.doctor_queue || 0) > 0) {
            return '진료 대기';
        }

        if ((this.queueCounts.review_queue || 0) > 0) {
            return '정리 대기';
        }

        return '현재 워크리스트';
    }

    public focusValue() {
        const nextVisit = this.queueCounts?.next_visit;
        if (nextVisit?.patient_name) {
            return nextVisit.patient_name;
        }

        if ((this.queueCounts.ops_queue || 0) > 0) {
            return `접수·예진 ${this.queueCounts.ops_queue}건`;
        }

        if ((this.queueCounts.doctor_queue || 0) > 0) {
            return `진료 ${this.queueCounts.doctor_queue}건`;
        }

        if ((this.queueCounts.review_queue || 0) > 0) {
            return `기록·처방 ${this.queueCounts.review_queue}건`;
        }

        return '대기 업무 없음';
    }

    public focusDetail() {
        const nextVisit = this.queueCounts?.next_visit;
        if (nextVisit?.patient_name) {
            const chartNo = nextVisit.patient_chart_number || '차트번호 없음';
            return `${chartNo} · ${this.nextVisitStatusLabel(nextVisit.status)}`;
        }

        if ((this.queueCounts.doctor_queue || 0) > 0) {
            return '대상 환자를 선택하면 차트로 바로 진입';
        }

        if ((this.queueCounts.review_queue || 0) > 0) {
            return '처방 마무리와 기록 확정이 남아 있습니다';
        }

        if ((this.queueCounts.ops_queue || 0) > 0) {
            return '접수 보드에서 신규 환자와 예진 연결을 확인';
        }

        return '오늘 보드에서 전체 흐름을 확인하세요';
    }

    public primaryActionLabel() {
        if (this.queueCounts?.next_visit?.id) return '차트 열기';
        if ((this.queueCounts.ops_queue || 0) > 0) return '접수 열기';
        if ((this.queueCounts.review_queue || 0) > 0) return '정리 열기';
        return '보드 열기';
    }

    public openPrimaryAction() {
        if (this.queueCounts?.next_visit?.id) {
            this.service.href(`/chart/${this.queueCounts.next_visit.id}`);
            return;
        }

        if ((this.queueCounts.ops_queue || 0) > 0) {
            this.service.href('/reception');
            return;
        }

        if ((this.queueCounts.review_queue || 0) > 0) {
            this.openReviewQueue();
            return;
        }

        this.service.href('/dashboard');
    }

    public profileClass() {
        if (this.isActive('/mypage')) {
            return 'profile-card profile-card--active';
        }
        return 'profile-card';
    }

    public roleLabel() {
        const role = this.service.auth.session?.role || '';
        const map: any = {
            superadmin: '총괄 운영',
            admin: '관리자',
            doctor: '진료',
            nurse: '접수',
            staff: '스태프',
            user: '사용자',
        };
        return map[role] || role;
    }

    public isAdmin() {
        const role = this.service.auth.session?.role;
        return role === 'admin' || role === 'superadmin';
    }

    private buildNavGroups(): NavGroup[] {
        const adminGroup: NavGroup = {
            label: 'ADMIN',
            roles: ['admin', 'superadmin'],
            items: [
                NAV_ITEMS.prompt,
                NAV_ITEMS.diagnosis,
                NAV_ITEMS.herbs,
                NAV_ITEMS.acupoints,
                NAV_ITEMS.users,
                NAV_ITEMS.settings,
                NAV_ITEMS.members,
                NAV_ITEMS.scenario,
            ]
        };

        if (this.isOpsRole()) {
            return [
                {
                    label: 'WORKLIST',
                    items: [
                        NAV_ITEMS.reception,
                        NAV_ITEMS.workspace,
                        NAV_ITEMS.prescriptions,
                    ]
                },
                {
                    label: 'RECORDS',
                    items: [
                        NAV_ITEMS.patients,
                        NAV_ITEMS.intake,
                    ]
                },
                {
                    label: 'COMMUNICATION',
                    items: [
                        NAV_ITEMS.posts,
                    ]
                },
                adminGroup,
            ];
        }

        return [
            {
                label: 'WORKLIST',
                items: [
                    NAV_ITEMS.workspace,
                    NAV_ITEMS.reception,
                    NAV_ITEMS.prescriptions,
                ]
            },
            {
                label: 'RECORDS',
                items: [
                    NAV_ITEMS.patients,
                    NAV_ITEMS.intake,
                ]
            },
            {
                label: 'COMMUNICATION',
                items: [
                    NAV_ITEMS.posts,
                ]
            },
            adminGroup,
        ];
    }

    private canAccess(roles?: string[]) {
        if (!roles || roles.length === 0) return true;

        const role = this.currentRole();
        if (roles.includes(role)) return true;
        if (role === 'superadmin' && roles.includes('admin')) return true;
        return false;
    }

    private currentRole() {
        return this.service.auth.session?.role || '';
    }

    private isOpsRole() {
        const role = this.currentRole();
        return role === 'nurse' || role === 'staff';
    }

    private nextVisitStatusLabel(status: string) {
        const map: any = {
            ready: '진료대기',
            in_progress: '진료중',
            charting: '기록정리',
            prescribing: '처방정리',
        };
        return map[status] || '진행중';
    }

    private isActive(link: string) {
        return location.pathname === link || location.pathname.startsWith(`${link}/`);
    }
}

export default ComponentNavSidebarComponent;